import React, { useEffect, useState, Fragment } from 'react';
import { CTAButton, CHECKOUT_URL } from './CTAButton';
import { Star, Shield } from 'lucide-react';
const PRODUCT_IMG = 'https://cdn.magicpatterns.com/uploads/h1K7wchd8DrbaDPHhF3buh/ChatGPT-Image-22-jun-2026_-22_30_15.webp';
export function PricingCard() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 1,
    minutes: 30,
    seconds: 5
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        let {
          hours,
          minutes,
          seconds
        } = prev;
        if (seconds > 0) seconds--;else if (minutes > 0) {
          minutes--;
          seconds = 59;
        } else if (hours > 0) {
          hours--;
          minutes = 59;
          seconds = 59;
        } else {
          hours = 1;
          minutes = 30;
          seconds = 5;
        }
        return {
          hours,
          minutes,
          seconds
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  return <section id="pricing" className="py-12 px-4 sm:px-6 bg-brand-paper border-b border-gray-200 scroll-mt-4" data-id="element-137">
      <div className="text-center mb-8" data-id="element-138">
        <p className="text-xs font-black text-brand-red uppercase tracking-widest mb-2" data-id="element-139">
          SPECIAL OFFER — COMPLETE 6-IN-1 PACK
        </p>
        <p className="text-sm font-bold text-brand-ink mb-4 leading-tight" data-id="element-140">
          Access the system now and transform your coaching process today.
        </p>
        <div className="inline-block bg-brand-navy text-white px-4 py-2 rounded shadow-md mb-6" data-id="element-141">
          <p className="font-bold text-sm tracking-wide uppercase" data-id="element-142">
            🏃 RUNNING COACH READY™ — 6-in-1 Complete Box Set
          </p>
        </div>

        <a href={CHECKOUT_URL} className="block cursor-pointer" data-id="element-143">
          <img src={PRODUCT_IMG} alt="Running Coach Ready Box Set" className="w-full max-w-[300px] mx-auto object-contain drop-shadow-xl hover:scale-105 transition-transform duration-300 mb-2" data-id="element-144" />
        </a>
      </div>

      <div className="bg-white border-4 border-brand-red rounded-xl p-6 text-center relative mb-6 shadow-2xl max-w-md mx-auto" data-id="element-145">
        <div className="mb-6" data-id="element-146">
          <p className="text-sm font-bold text-brand-ink/50 mb-1" data-id="element-147">
            Normal Price: <span className="line-through" data-id="element-148">$97 USD</span>
          </p>
          <p className="text-base font-black text-brand-red mb-2 uppercase tracking-wide" data-id="element-149">
            🔥 72% OFF — LAUNCH OFFER
          </p>
          <p className="text-6xl font-heading font-black text-brand-navy mb-1 leading-none" data-id="element-150">
            $27 USD
          </p>
          <p className="text-[10px] font-bold text-brand-ink/50 uppercase tracking-wider mt-2" data-id="element-151">
            Pay in your local currency
          </p>
        </div>

        <div className="bg-brand-paper border-2 border-brand-red/20 rounded-lg p-4 mb-6" data-id="element-152">
          <p className="text-xs font-bold text-brand-red mb-3 uppercase tracking-tight" data-id="element-153">
            🔥 Last chance! The price increases when the timer ends.
          </p>
          <div className="flex justify-center gap-3" data-id="element-154">
            {[{
            v: timeLeft.hours,
            l: 'HOURS'
          }, {
            v: timeLeft.minutes,
            l: 'MINUTES'
          }, {
            v: timeLeft.seconds,
            l: 'SECONDS'
          }].map((unit, idx) => <Fragment key={unit.l} data-id="element-155">
                {idx > 0 && <div className="text-2xl font-black text-brand-ink/30 mt-1" data-id="element-156">
                    :
                  </div>}
                <div className="text-center" data-id="element-157">
                  <div className="bg-brand-red text-white font-heading text-3xl font-black px-3 py-2 rounded shadow-inner leading-none min-w-[56px]" data-id="element-158">
                    {String(unit.v).padStart(2, '0')}
                  </div>
                  <p className="text-[9px] font-bold text-brand-ink/60 mt-2 tracking-wider uppercase" data-id="element-159">
                    {unit.l}
                  </p>
                </div>
              </Fragment>)}
          </div>
        </div>

        <CTAButton checkout data-id="element-160">🚀 YES, I WANT THE 6-IN-1 PACK</CTAButton>
      </div>

      <div className="flex flex-col sm:flex-row justify-center items-center gap-2 sm:gap-6 text-xs text-brand-navy font-bold" data-id="element-161">
        <div className="flex items-center gap-1.5" data-id="element-162">
          <Star className="w-4 h-4 fill-brand-gold text-brand-gold" data-id="element-163" />
          <span data-id="element-164">4.9/5 — Verified Reviews</span>
        </div>
        <div className="flex items-center gap-1.5" data-id="element-165">
          <Shield className="w-4 h-4 text-brand-green" data-id="element-166" />
          <span data-id="element-167">7-Day Guarantee — Zero Risk</span>
        </div>
      </div>
    </section>;
}